import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithCustomManagedStream,
} from 'widgets/WidgetRegistry.ts';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import HistoricalPercentageChangeWidget from './components/HistoricalPercentageChangeWidget';
import { historicalPercentageChangeWidgetDescription } from './components/description/historicalPercentageChangeWidgetDescription';
import { buildHistoricalPercentageChangeStoreSlice } from 'widgets/historicalPercentageChange/store/slice.ts';
import { WidgetType } from 'widgets/WidgetType.ts';
import { initialHistoricalPercentageChangeWidgetConfigState } from 'widgets/historicalPercentageChange/widget/store.ts';
import { HistoricalPercentageChangeConfig } from 'widgets/historicalPercentageChange/store/HistoricalPercentageChangeConfig.ts';
import { histPriceVolStreamConfig } from 'widgets/historicalPercentageChange/store/data/stream-config.ts';

const { initialConfigState } = buildHistoricalPercentageChangeStoreSlice(
    WidgetType.HistoricalPercentageChangeWidget,
    initialHistoricalPercentageChangeWidgetConfigState
).configSlice;

export const historicalPercentageChangeWidgetStrategy: WidgetStrategyWithConfig<HistoricalPercentageChangeConfig> &
    WidgetStrategyWithCustomManagedStream = {
    title: 'Historical Percentage Change',
    supportedHosts: ['layout'],
    reactComponentType: HistoricalPercentageChangeWidget,
    categories: [WidgetCategory.SINGLE_STOCK],
    description: historicalPercentageChangeWidgetDescription,
    portfolioSelectionRequirements: PortfolioSelectionRequirements.SingleSymbol,
    initialConfigState,
    managedStreamConfig: histPriceVolStreamConfig,
};
